import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { api } from '../lib/api-client';

export function useAdmin() {
  const { user } = useAuth();

  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';
  const isSuperAdmin = user?.role === 'super_admin';

  const adminApi = useMemo(
    () => ({
      get: <T>(path: string) => api.get<T>(`/admin${path}`),
      post: <T>(path: string, body?: unknown) => api.post<T>(`/admin${path}`, body),
      patch: <T>(path: string, body?: unknown) => api.patch<T>(`/admin${path}`, body),
      delete: <T>(path: string) => api.delete<T>(`/admin${path}`),
    }),
    [],
  );

  return { isAdmin, isSuperAdmin, adminApi };
}
